import { render, staticRenderFns } from "./BoxListEmptyCard.vue?vue&type=template&id=45514be8&scoped=true&"
import script from "./BoxListEmptyCard.vue?vue&type=script&lang=js&"
export * from "./BoxListEmptyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45514be8",
  null
  
)

export default component.exports